import React, { useEffect, useState } from 'react';
import {
  CreateRiskActivityTargetsComp,
  DatatableRiskActivityTargets,
  EditRiskActivityTargetsComp,
} from '../../components/moleculs';
import axios from '../../library/axios';
import { useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { MySwal } from '../../library/swal';
import { useNavigate } from 'react-router-dom';
import { IconSquareRoundedPlus } from '@tabler/icons-react';
import { useLocation } from 'react-router-dom';
import { LoadingAtom } from '../../components/atoms';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, useNavigateWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiError, notifyApiLoadError } from '../../helpers/notifyApiError';

const RiskActivityTargetsPage = () => {
  const routeParams = useParams();
  const location = useLocation();
  const navigate = useNavigateWithSlugHook();

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [listRiskActivity, setlistRiskActivity] = useState([]);
  const [editRiskActivity, seteditRiskActivity] = useState([]);

  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [loadingData, setloadingData] = useState(true);
  const [role, setRole] = useState('');

  const fetchListRiskActivity = async () => {
    try {
      const options = {
        url: `/activity-targets/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setloadingData(false);
      }, 1000);
      setlistRiskActivity(data);
      setFilterData(data);
    } catch (err) {
      setloadingData(false);
      notifyApiLoadError(err, 'pages/risk-activity-targets/index.fetchListRiskActivity');
    }
  };

  const handleHapus = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/activity-targets/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Kegiatan Sasaran Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchListRiskActivity();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
            notifyApiError(err, { context: 'pages/risk-activity-targets/index.handleHapus' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-activity-targets/index.fetchOneUser');
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
    fetchListRiskActivity();
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEdit = (editRiskActivity) => {
    seteditRiskActivity(editRiskActivity);
    setLgShowUpdate(true);
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-activity-targets/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    const result = listRiskActivity?.filter((item) => {
      let name = item.name;
      let goals = item.goals;
      let owner = item.owner;
      let riskCategory = item.riskCategory;

      return name
        .concat(goals)
        .concat(owner)
        .concat(riskCategory)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterData(result);
  }, [search]);

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Manajemen Risiko
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            {/* <ActionBarPpsItemComp showFormAdd={() => setLgShowAdd(true)} /> */}
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-5">
                      <div>
                        <h5 className="card-title text-primary">
                          Daftar Kegiatan Sasaran dan Pemilik Risikonya
                        </h5 >
                      </div >
                      <div>
                        {loadingData === true ? (
                          ''
                        ) : (
                          <>
                            {role === 'Administrator' ||
                              role === 'Kelompok Kerja' ||
                              role === 'Surveior Internal' ? (
                              <a
                                onClick={() => setLgShowAdd(true)}
                                className="btn btn-sm btn-primary"
                              >
                                <IconSquareRoundedPlus stroke={2} /> Tambah
                                Kegiatan & Sasaran
                              </a>
                            ) : (
                              ''
                            )}
                          </>
                        )}
                      </div>
                    </div >
                    {loadingData === true ? (
                      <LoadingAtom />
                    ) : (
                      <>
                        <DatatableRiskActivityTargets
                          listRiskActivityTargets={filterData}
                          search={search}
                          role={role}
                          handleChangeSearch={handleChangeSearch}
                          handleEdit={handleEdit}
                          handleHapus={handleHapus}
                        />
                      </>
                    )}
                  </div >
                </div >
              </div >
              {/*end::Col*/}
            </div >
            {/*end::Row*/}
          </div >
          {/*end::Container*/}
        </div >
        {/*end::Post*/}
      </div >
      {/*end::Content*/}

      < Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">Form Laporan Kegiatan Sasaran Risiko</b>
          </Modal.Title >
        </Modal.Header >
        <Modal.Body>
          <CreateRiskActivityTargetsComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchListRiskActivity()}
            riskActivity={listRiskActivity}
          />
        </Modal.Body>
      </Modal >

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b className="text-primary">
              Form Ubah Laporan Kegiatan Sasaran Risiko
            </b>
          </Modal.Title>
        </Modal.Header >
        <Modal.Body>
          <EditRiskActivityTargetsComp
            editRiskActivity={editRiskActivity}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchListRiskActivity()}
          />
        </Modal.Body>
      </Modal >
    </>
  );
};

export default RiskActivityTargetsPage;
